import { Search } from "@mui/icons-material"
import { MenuItem, InputAdornment } from "@mui/material"
import { StyledSearchBox, StyledSelect, StyledTextField } from "./styles"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import {
  getSearchList,
  selectTransactions,
  setFilters,
} from "../../slices/transactionsSlice"
import { useEffect } from "react"

const CustomSearchBox = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(getSearchList())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const { filters, searchList } = useAppSelector(selectTransactions)

  return (
    <StyledSearchBox>
      <StyledSelect
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={filters.searchType}
        size="small"
        sx={{ width: 160 }}
        onChange={(e: any) =>
          dispatch(
            setFilters({
              ...filters,
              searchType: e.target.value as string,
              operator: "",
              search: "",
            }),
          )
        }
      >
        {searchList.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            {option.value}
          </MenuItem>
        ))}
      </StyledSelect>
      <StyledTextField
        size="small"
        variant="outlined"
        placeholder="Search Transactions..."
        value={filters.search}
        onChange={(e) => {
          dispatch(setFilters({ ...filters, search: e.target.value }))
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
        }}
      />
    </StyledSearchBox>
  )
}
export default CustomSearchBox
